const marketing = {
  meta: {
    title: "TGReposter — پلتفرم هوشمند مدیریت محتوای تلگرام",
    description: "محتوای تلگرام را در یک فضای کاری خصوصی جمع‌آوری، فیلتر، بهینه، بازبینی و منتشر کنید.",
  },
  accessibility: {
    home: "صفحه اصلی TGReposter",
    mainNavigation: "ناوبری اصلی",
    mobileNavigation: "ناوبری موبایل",
    openMenu: "باز کردن منو",
    closeMenu: "بستن منو",
    flowImage: "نمای انتزاعی جریان محتوا از پردازش هوش مصنوعی تا مقصدهای تلگرام",
  },
  nav: {
    salesPlan: "طرح‌های فروش",
    workflow: "نحوه کار",
    capabilities: "قابلیت‌ها",
    security: "امنیت",
    demo: "درخواست دمو",
    dashboard: "باز کردن داشبورد",
  },
  hero: {
    badge: "عملیات محتوای تلگرام با هوش مصنوعی",
    title: "شلوغی تلگرام را به سیگنال انتشار تبدیل کنید.",
    body: "کانال‌های مهم را پایش کنید، پست‌ها را با هوش مصنوعی بهبود دهید و محتوای تأییدشده را از یک فضای کاری خصوصی به همه مقصدهای تلگرام منتشر کنید.",
    primary: "درخواست دسترسی دمو",
    secondary: "مشاهده روند کار",
    humanApproved: "انتشار با تأیید انسانی",
    isolated: "فضای کاری مستقل برای هر کاربر",
    stack: "هماهنگ با زیرساخت شما",
  },
  workflow: {
    eyebrow: "یک روند پیوسته",
    title: "از کانال منبع تا پست منتشرشده.",
    body: "TGReposter جمع‌آوری، فیلتر، بهبود با هوش مصنوعی، بازبینی تحریریه و توزیع را در یک روند قابل‌ردیابی نگه می‌دارد و تصمیم نهایی انتشار را به انسان می‌سپارد.",
    collect: { title: "جمع‌آوری", copy: "کانال‌های عمومی تلگرامی را که برای شما مهم هستند پایش کنید." },
    filter: { title: "فیلتر", copy: "پست‌های مفید را نگه دارید و نویز را با قوانین خود حذف کنید." },
    refine: { title: "بهبود", copy: "با هوش مصنوعی بازنویسی، خلاصه‌سازی، ترجمه و هشتگ‌سازی کنید." },
    publish: { title: "انتشار", copy: "یک‌بار بازبینی کنید و سپس به یک یا چند مقصد تلگرام بفرستید." },
  },
  inbox: {
    title: "صندوق محتوا",
    status: "آماده بازبینی",
    matched: "۱۲ مورد منطبق",
    now: "اکنون",
    first: { title: "به‌روزرسانی زیرساخت هوش مصنوعی", action: "خبر" },
    second: { title: "انتشار مدل متن‌باز", action: "ترجمه" },
    third: { title: "گزارش اکوسیستم تلگرام", action: "خلاصه" },
  },
  capabilities: {
    eyebrow: "اتاق کنترل تحریریه",
    title: "اتوماسیون جایی که کمک می‌کند؛ قضاوت انسانی جایی که اهمیت دارد.",
    body: "از هوش مصنوعی برای افزایش سرعت استفاده کنید، بدون اینکه کنترل لحن و پیام خود را از دست بدهید. هر پست پیش از انتشار قابل ویرایش و بازبینی می‌ماند.",
    items: {
      privateInbox: "صندوق محتوای خصوصی برای هر کاربر",
      aiProviders: "پشتیبانی از Gemini و OpenRouter",
      humanReview: "بازبینی انسانی پیش از انتشار",
      multiDestination: "ارسال هم‌زمان به چند مقصد",
      campaigns: "کمپین برای کانال، گروه و سوپرگروه",
      roles: "دسترسی تیمی مبتنی بر نقش",
    },
  },
  cards: {
    curation: {
      eyebrow: "کیوریشن محتوا",
      title: "از کانال‌های تحت پایش، یک فید متمرکز بسازید.",
      body: "پست‌های منطبق را جمع‌آوری کنید، تبلیغات ناخواسته را حذف کنید، متن را بهبود دهید و فقط محتوای ارزشمند را منتشر کنید.",
    },
    campaign: {
      eyebrow: "توزیع کمپین",
      title: "یک پیام تأییدشده را در شبکه تلگرامی خود منتشر کنید.",
      body: "ارسال به کانال‌ها، گروه‌ها و سوپرگروه‌ها را هماهنگ کنید و نتیجه هر مقصد را مستقل نگه دارید.",
    },
  },
  security: {
    eyebrow: "حریم خصوصی در طراحی",
    title: "فضای کاری شما فقط متعلق به شماست.",
    body: "منابع، فیلترها، پست‌های صندوق محتوا، مقصدها، کمپین‌ها و ترجیحات هوش مصنوعی برای هر کاربر جدا هستند. اطلاعات حساس در بک‌اند باقی می‌مانند و با احراز هویت و دسترسی مبتنی بر نقش محافظت می‌شوند.",
  },
  salesPlan: {
    "eyebrow": "طرح فروش · قیمت‌های پیشنهادی",
    "title": "یک پلتفرم، طرحی برای هر مقیاس فعالیت در تلگرام.",
    "intro": "از گزینش محتوا شروع کنید و به انتشار چندکاناله، کمپین‌ها و کار تیمی گسترش دهید.",
    "billingLabel": "دوره پرداخت",
    "periods": {
      "monthly": "ماهانه",
      "annual": "سالانه"
    },
    "notice": "این بخش پیش‌نمایش قیمت‌های مصوب و محدودیت‌های برنامه‌ریزی‌شده است. خرید اشتراک، پرداخت و بسته‌های افزایشی هوش مصنوعی هنوز فعال نیست. برای بررسی طرح مناسب درخواست دمو بدهید.",
    "popular": "محبوب‌ترین",
    "custom": "توافقی",
    "perMonth": "/ ماه",
    "enterpriseBilling": "قرارداد اختصاصی",
    "freeForever": "همیشه رایگان",
    "monthlyCharge": "پرداخت ماهانه",
    "annualCharge": "پرداخت سالانه {{price}}",
    "plannedLimits": "سقف‌های برنامه‌ریزی‌شده",
    "metrics": {
      "users": "اعضای تیم",
      "sources": "منابع تحت پایش",
      "destinations": "مقصدهای انتشار",
      "campaigns": "کمپین‌های فعال",
      "ai": "واحد هوش مصنوعی / ماه",
      "history": "تاریخچه انتشار"
    },
    "history": {
      "days7": "۷ روز",
      "days90": "۹۰ روز",
      "year1": "۱ سال",
      "year2": "۲ سال",
      "year3": "۳ سال",
      "custom": "توافقی"
    },
    "request": "درخواست دسترسی",
    "contact": "گفت‌وگو با تیم",
    "discussPlan": "گفت‌وگو درباره طرح {{plan}}",
    "annualSavings": "با پرداخت سالانه تا ۱۷٪ صرفه‌جویی کنید؛ معادل تقریباً دو ماه رایگان.",
    "plans": {
      "free": {
        "name": "Free",
        "audience": "شروع",
        "description": "گردش کار اصلی محتوا را با چند کانال تجربه کنید."
      },
      "creator": {
        "name": "Creator",
        "audience": "تولیدکنندگان محتوا",
        "description": "زمان کمتری برای گزینش و انتشار محتوا صرف کنید."
      },
      "professional": {
        "name": "Professional",
        "audience": "مدیران چند کانال",
        "description": "پایش، انتشار و ترویج را در یک فضای کاری مدیریت کنید."
      },
      "business": {
        "name": "Business",
        "audience": "تیم‌های رسانه‌ای",
        "description": "فعالیت محتوایی را با همکاری تیمی گسترش دهید."
      },
      "agency": {
        "name": "Agency",
        "audience": "شبکه‌های کانالی",
        "description": "شبکه‌های بزرگ‌تر انتشار و کمپین‌ها را هماهنگ کنید."
      },
      "enterprise": {
        "name": "Enterprise",
        "audience": "سازمان‌ها",
        "description": "درباره ظرفیت، حاکمیت، یکپارچه‌سازی و پشتیبانی اختصاصی گفت‌وگو کنید."
      }
    },
    "topUps": {
      "eyebrow": "ظرفیت افزایشی هوش مصنوعی",
      "title": "در صورت نیاز واحدهای بیشتری بگیرید.",
      "description": "بسته‌های افزایشی پیشنهادی، سهمیه ماهانه هر اشتراک را تکمیل می‌کنند.",
      "units": "{{units}} واحد هوش مصنوعی",
      "note": "واحدهای هوش مصنوعی با میزان مصرف مدل محاسبه می‌شوند، نه تعداد ثابت عملیات. خرید بسته‌ها و حسابداری تجاری هنوز فعال نیست.",
      "packs": {
        "mini": "AI Mini",
        "plus": "AI Plus",
        "pro": "AI Pro",
        "max": "AI Max"
      }
    }
  },
  cta: {
    eyebrow: "در جریان کاری خودتان ببینید",
    title: "دسترسی دمو درخواست کنید.",
    body: "کمی درباره روند کاری تلگرام خودتان بگویید. ما کاربرد موردنظر شما را بررسی می‌کنیم و اطلاعات مناسب برای دسترسی دمو را می‌فرستیم.",
    button: "درخواست دمو",
    points: {
      tailored: "نمایش متناسب با روند کیوریشن محتوا، کمپین‌ها یا هر دو",
      private: "درخواست شما به‌صورت خصوصی توسط تیم TGReposter بررسی می‌شود",
      human: "ثبت‌نام خودکار وجود ندارد — دسترسی دمو پس از بررسی درخواست ارائه می‌شود",
    },
  },
  demoForm: {
    eyebrow: "دسترسی دمو",
    title: "بگویید TGReposter کجا باید به شما کمک کند.",
    fullName: "نام شما",
    fullNamePlaceholder: "سارا احمدی",
    email: "ایمیل",
    emailPlaceholder: "sara@company.com",
    company: "شرکت / تیم (اختیاری)",
    companyPlaceholder: "نام سازمان",
    telegram: "نام کاربری تلگرام (اختیاری)",
    telegramPlaceholder: "@username",
    useCase: "می‌خواهید TGReposter را برای چه کاری استفاده کنید؟",
    useCases: {
      curation: "کیوریشن محتوا و بازنشر",
      campaigns: "کمپین‌های تبلیغاتی",
      both: "کیوریشن و کمپین‌ها",
      other: "کاربرد دیگر",
    },
    message: "در دمو چه چیزی را می‌خواهید ببینید؟ (اختیاری)",
    messagePlaceholder: "درباره کانال‌ها، روند کاری یا مسئله‌ای که می‌خواهید حل کنید توضیح دهید.",
    submit: "درخواست دسترسی دمو",
    submitting: "در حال ارسال درخواست…",
    privacy: "از این اطلاعات فقط برای بررسی درخواست دمو و تماس با شما درباره TGReposter استفاده می‌کنیم.",
    successTitle: "درخواست دریافت شد.",
    successBody: "متشکریم. کاربرد موردنظر شما را بررسی می‌کنیم و برای مرحله بعدی دسترسی دمو با شما تماس می‌گیریم.",
    submitAnother: "ارسال درخواست دیگر",
    error: "ارسال درخواست انجام نشد. اتصال خود را بررسی کنید و دوباره تلاش کنید.",
  },
  footer: {
    salesPlan: "طرح‌های فروش",
    workflow: "روند کار",
    capabilities: "قابلیت‌ها",
    security: "امنیت",
    demo: "درخواست دمو",
    dashboard: "داشبورد",
  },
} as const;

export default marketing;
